module.exports = __webpack_public_path__ + "img/icon_4_43.8a1c4588.png";